import { PlusSquareIcon, QuestionIcon } from '@chakra-ui/icons'
import {
  ChakraProvider,
  HStack,
  Stack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  VStack,
  Text,
  useDisclosure,
  Input,
  Textarea,
  Image,
  Checkbox,
  CheckboxGroup,
  Select as ChakraSelect,
} from '@chakra-ui/react'
import { SingleDatepicker } from 'chakra-dayzed-datepicker'

import { MultiSelect, Option } from 'chakra-multiselect'
import { getHours, isWeekend, parse, addMinutes, isBefore, format, addDays } from 'date-fns'
import { useEffect, useState } from 'react'
import Api from '../api/api'
const AddNewReservation = ({
    date,
    reservationCreated,
    locations,
    editingReservation,
    stopEditingReservation,
  }: any) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const floorMapModal = useDisclosure()
  const [loading, setLoading] = useState(false)

  const defaultReservationData = {
    id: null,
    table: [],
    guests: 0,
    location: 'restaurant',
    comment: null,
    name: null,
    phone: null,
    time: '9:00',
    duration: '120',
    date: new Date(),
    inquiry: false,
    tasting: false,
  }

  const [reservation, setReservation] = useState(defaultReservationData)

  const getTables = () => {
      let tableConfig = [1,2,3,4,5,6,7,8,'9'];
      if (reservation.location === 'restaurant') {
          tableConfig = [101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 'CINEMA']
      } else if (reservation.location === 'to the room') {
          tableConfig = [111, 222, 333, 444, 555, 666, 777, 888, 999];
      } else if (reservation.location === 'terace') {
          tableConfig = [201, 202, 203, 204, 205, 206, 207, 208];
      }

      return tableConfig;
  }

  useEffect(() => {
    if (editingReservation && !isOpen) {
      let tempReservation = { ...defaultReservationData }
      const tempEditingReservation = { ...editingReservation }
      if (typeof tempEditingReservation.location === 'object') {
        tempEditingReservation.location = tempEditingReservation.location.location;
      }

      if (typeof tempEditingReservation.date === 'string') {
        tempEditingReservation.date = new Date(tempEditingReservation.date);
      }

      tempReservation = { ...tempEditingReservation }
      setReservation(tempReservation)
      onOpen()
    }
  }, [editingReservation]);

  const updateReservation = (key: string, value: any) => {
    if (key === 'table') {
      value = value.map((table: Option) => table.value ? table.value : table);
    }

    if (key === 'location' && value !== reservation.location) {
      setReservation({
        ...reservation,
        [key]: value,
        table: [],
      });

      return;
    }

    setReservation({
      ...reservation,
      [key]: value,
    })
  }

  const getHours = () => {
    if (!reservation) {
      return []
    }

    const hours = []
    let increase = true

    let startCounter = parse('08:00', 'HH:mm', new Date())
    const finishCounter = parse('23:59', 'HH:mm', new Date())

    while (increase) {
      hours.push({
        key: format(startCounter, 'H:mm'),
        value: format(startCounter, 'H:mm'),
      })
      startCounter = addMinutes(startCounter, 30)
      if (isBefore(finishCounter, startCounter)) {
        increase = false
      }
    }

    return hours
  }



  const getGuests = () => {
    const guests = []
    for (let i = 0; i <= 50; i++) {
      guests.push({
        key: i.toString(),
        value: i,
      })
    }
    return guests
  }

  const cancel = () => {
    setReservation(defaultReservationData)
    onClose()
  }

  const create = () => {
    if (reservation.table.length === 0) {
      alert('Please select table number');
      return;
    }

    const reservationData = {
      ...reservation,
    }
    setLoading(true)
    Api.createReservation(reservationData)
      .then(() => {
        setReservation(defaultReservationData)
        onClose()
        reservationCreated()
      })
      .finally(() => setLoading(false))
  }

  interface LocationEntry {
    location: string;
    title: string;
    id: string;
    type: string;
  }

  const getLocations = () => {
    return locations.filter((location: LocationEntry) => {
      if (location.type !== 'waiter') {
        return false;
      }

      if (location.location === 'restaurant') {
        return true;
      }

      if (location.location === 'terace') {
        return true;
      }

      return false;
    })
  }

  const closeModal = () => {
    setReservation(defaultReservationData)
    stopEditingReservation()
    onClose()
  }

  const deleteReservation = () => {
    setLoading(true)
    const confirmDelete = window.confirm(`Are you sure you want to delete ${reservation.name} reservation?`);
    if (!confirmDelete) {
      setLoading(false)
      return;
    }

    Api.deleteReservation(reservation.id)
      .then(() => {
        setReservation(defaultReservationData)
        onClose()
        reservationCreated()
      })
      .finally(() => setLoading(false))
  }

  const floorPlan = () => {
    if (reservation.location === 'restaurant') {
      return 'Restoranas';
    } else if (reservation.location === 'to the room') {
      return 'Apartamentai';
    } else if (reservation.location === 'terace') {
      return 'Terasa';
    }
    return 'Lobby';
  }

  const selectableDurations = () => {
    const durations = [
      {
        key: '30',
        value: ':30',
      },
      {
        key: '60',
        value: '1:00',
      },
    ];
    for (let i = 120; i <= 480; i += 30) {
      durations.push({
        key: i.toString(),
        value: format(addMinutes(parse('00:00', 'HH:mm', new Date()), i), 'H:mm')
      });
    }

    return durations;
  }

  return (
    <>
      <Button
        onClick={onOpen}
        position='fixed'
        bottom={4}
        right={4}
        variant='solid'
        colorScheme='green'
        zIndex={9}
      >
        <PlusSquareIcon />
      </Button>

      <Modal isOpen={isOpen} onClose={closeModal} size={'xl'}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{reservation.id ? 'Update reservation' : 'Create reservation'}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack alignItems='flex-start' spacing={4} w='full'>
              <HStack w='full'>
                <Text minWidth='90px'>Date:</Text>
                <SingleDatepicker
                  date={reservation.date}
                  onDateChange={(e) => updateReservation('date', e)}
                  // propsConfigs={{
                  //   inputProps: {
                  //     color: 'white',
                  //     maxWidth: '240px',
                  //   },
                  //   dayOfMonthBtnProps: {
                  //     isInRangeBtnProps: {
                  //       color: 'white',
                  //       background: 'blackAlpha.800',
                  //       border: 'none',
                  //       _hover: {
                  //         bg: 'green.400',
                  //       },
                  //     },
                  //     selectedBtnProps: {
                  //       color: 'white',
                  //       background: 'blackAlpha.800',
                  //       border: 'none',
                  //       _hover: {
                  //         bg: 'green.400',
                  //       },
                  //     },
                  //     defaultBtnProps: {
                  //       background: 'white',
                  //       border: 'none',
                  //       _hover: {
                  //         bg: 'green.400',
                  //         color: 'white',
                  //       },
                  //     },
                  //   },
                  //   popoverCompProps: {
                  //     popoverContentProps: {
                  //       rootProps: { background: 'red', zIndex: 99999 },
                  //     },
                  //   },
                  // }}
                  configs={{
                    dateFormat: 'yyyy-MM-dd',
                    firstDayOfWeek: 1,
                  }}
                />
              </HStack>
              <HStack w='full'>
                <Text minWidth='90px'>Time:</Text>
                <ChakraSelect
                  defaultValue={reservation.time}
                  variant='filled'
                  onChange={(e) => updateReservation('time', e.target.value)}
                >
                  {getHours().map((option) => (
                    <option key={option.key} value={option.key}>
                      {option.value}
                    </option>
                  ))}
                </ChakraSelect>
              </HStack>
              <HStack w='full'>
                <Text minWidth='90px'>Duration:</Text>
                <ChakraSelect
                  defaultValue={reservation.duration}
                  variant='filled'
                  onChange={(e) => updateReservation('duration', e.target.value)}
                >
                  {selectableDurations().map((option) => (
                    <option key={option.key} value={option.key}>
                      {option.value}
                    </option>
                  ))}
                </ChakraSelect>
              </HStack>
              <HStack w='full'>
                <HStack minWidth='90px' onClick={floorMapModal.onOpen}>
                  <Text>Location:</Text>
                  <QuestionIcon color='gray.500' ml={1} />
                </HStack>
                <ChakraSelect
                  defaultValue={reservation.location}
                  variant='filled'
                  onChange={(e) => updateReservation('location', e.target.value)}
                >
                  {getLocations().map((option: LocationEntry) => (
                    <option key={`location-selector-${option.id}`} value={option.location}>
                      {option.title}
                    </option>
                  ))}
                </ChakraSelect>
              </HStack>
              <HStack w='full'>
                <Text minWidth='90px'>Table No:</Text>
                <div style={{ width: '100%' }}>
                  <MultiSelect
                    style={{ width: '100%', backgroundColor: 'red' }}
                    onChange={(e) => updateReservation('table', e)}
                    options={getTables().map((table) => {
                      return { label: table.toString(), value: table.toString() }
                    })}
                    value={reservation.table}
                  />
                </div>
              </HStack>
              <HStack w='full'>
                <Text minWidth='90px'>Name:</Text>
                <Input
                  value={reservation.name ?? ''}
                  onChange={(e) => updateReservation('name', e.target.value)}
                />
              </HStack>
              <HStack w='full'>
                <Text minWidth='90px'>Phone:</Text>
                <Input
                  value={reservation.phone ?? ''}
                  onChange={(e) => updateReservation('phone', e.target.value)}
                />
              </HStack>
              <HStack w='full'>
                <Text minWidth='90px'>Guests:</Text>
                <ChakraSelect
                  defaultValue={reservation.guests}
                  variant='filled'
                  onChange={(e) => updateReservation('guests', e.target.value)}
                >
                  {getGuests().map((option) => (
                    <option key={option.key} value={option.key}>
                      {option.value}
                    </option>
                  ))}
                </ChakraSelect>
              </HStack>
              <HStack w='full'>
                <Text minWidth='90px'>Inquiry:</Text>
                <Checkbox
                  size='md'
                  colorScheme='green'
                  isChecked={reservation.inquiry}
                  onChange={(e) => updateReservation('inquiry', e.target.checked)}
                />
              </HStack>
              <HStack w='full'>
                <Text minWidth='90px'>Event:</Text>
                <Checkbox
                  size='md'
                  colorScheme='green'
                  isChecked={reservation.tasting}
                  onChange={(e) => updateReservation('tasting', e.target.checked)}
                />
              </HStack>
              <HStack w='full'>
                <Text minWidth='90px'>Comment:</Text>
                <Textarea
                  value={reservation.comment ?? ''}
                  rows={6}
                  onChange={(e) => updateReservation('comment', e.target.value)}
                />
              </HStack>
            </VStack>
          </ModalBody>

          <ModalFooter justifyContent={reservation.id ? 'space-between' : 'end'}>
            {reservation.id && (
              <Button colorScheme='red' ml={0} onClick={deleteReservation} isLoading={loading}>
                Delete
              </Button>
            )}
            <HStack>
              <Button colorScheme='facebook' ml={0} onClick={cancel} isLoading={loading}>
                Close
              </Button>
              <Button colorScheme='green' mr={0} onClick={create} isLoading={loading}>
                {reservation.id ? 'Update' : 'Create'}
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={floorMapModal.isOpen} onClose={floorMapModal.onClose} size='4xl'>
        <ModalOverlay zIndex='9999999' />
        <ModalContent containerProps={{ zIndex: '9999999' }}>
          <ModalHeader>{floorPlan()}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Image src={`/assets/tables/${floorPlan()}.png`} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

export default AddNewReservation
